import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import {
  ADDRESS_BY_CHAIN_CRONOS_EVM,
  getRelatedCronosEvmChain,
} from '@cronos-app/sdk';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getMERYToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.MERY,
    symbol: 'MERY',
    addressL1: '',
    addressL2: sdks.L2.getContractAddress('MERY'),
    addressCronosEvm:
      ADDRESS_BY_CHAIN_CRONOS_EVM[getRelatedCronosEvmChain(desiredNetwork)]
        .MERY,
    decimals: 18,
    displayDecimals: 6,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/mery.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="MERY"
        {...props}
      />
    ),
  };
};
